import {hideElementsBySelector, showElementsBySelector} from "@/helpers/element-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {isMobile} from "@/helpers/mobile-helper.js";

export function hideButtonsBySettings(buttons) {

    for (const [key, value] of Object.entries(buttons[2])) {
        showElementsBySelector('.' + value)

        if (value === "divOverViewMap" && !isMobile()) {
            window.overviewMapControl.setCollapsed(!window.overviewMapControl.getCollapsed());
        }
    }

    for (const [key, value] of Object.entries(buttons[3])) {
        showElementsBySelector('.' + value)
    }

    if('Dataportaal' in buttons[3] ||
        'Help' in buttons[3] ||
        'Taal' in buttons[3] ||
        'Volledig scherm' in buttons[3]
    ) {
        showElementsBySelector('header-settings')
    }

    // 3D only works in EPSG:2857
    if(getViewProjectionName() !== 'EPSG:3857') {
        hideElementsBySelector('cesium-enable')
    }
}
